<script setup lang="ts">
import Toaster from '@/components/Toaster.vue'
import { useMagicKeys, whenever } from '@vueuse/core'
import { useAppStore } from './store/appStore'

const appStore = useAppStore()
const keys = useMagicKeys()

// Global keybindings
whenever(keys.ctrl_l, () => {
  document?.getElementById('site-search')?.focus()
})

whenever(keys.ctrl_h, () => {
  if (appStore.showHelp === null) {
    appStore.goToDocs()
  } else {
    appStore.closeHelp()
  }
})

whenever(keys.ctrl_o, () => {
  document?.getElementById('org-picker-trigger')?.click()
})

whenever(keys.ctrl_t, () => {
  if (appStore.showHelp !== 'SUPPORT') {
    appStore.startTicket({})
  } else {
    appStore.closeHelp()
  }
})
</script>

<template>
  <router-view />
  <Toaster />
</template>
